export const BULK_CONTROLS_TITLE_COLUMN_ID = "title";
export const BULK_CONTROLS_CONTROL_PROGRAM_COLUMN_ID = "controlProgram";
export const BULK_CONTROLS_SCHEDULING_INTERVAL_COLUMN_ID = "schedulingInterval";
export const BULK_CONTROLS_ESTIMATED_ACTIVITIES_COLUMN_ID =
    "estimatedActivities";
